// @flow
import React from 'react';
import type { SocialContent } from 'types/SocialContent';
import { getTimeDifference } from 'utils/dateUtils';
import Label from 'components/fragments/text/Label';

type Props = {
  content: SocialContent,
  transparent?: boolean,
  onClick: Function
};

const InstagramCard = (props: Props) => {
  const { backgroundImage, description, comments, likes, link } = props.content;
  const date = props.content.date instanceof Date ? props.content.date : new Date(props.content.date);

  return (
    <a 
      href={link}
      target={'_blank'}
      rel={'noopener noreferrer'}
      onClick={props.onClick}
      className="box card card--social"
      title="Voir ce contenu sur Instagram"
      style={{ opacity: props.transparent ? 0.3 : 1 }}>
      {backgroundImage && (
        <div className="card__thumbnail" style={{ backgroundImage: `url(${backgroundImage})` }} />
      )}
      <div className="card__body">
        <p className="card__desc ft-secondary" dangerouslySetInnerHTML={{ __html: description }} />
      </div>
      <div className="card__footer ft-h6">
        <div className="card__stat">
          {comments > 0 && 
          <span>
            <i className="icon icon-coment-insta" />
            {comments}
          </span>}
          {likes > 0 &&
          <span>
            <i className="icon icon-like-insta" />
            {likes}
          </span>}
        </div>
        <span className="ft-up">{`${getTimeDifference(new Date(), date)}`}</span>
      </div>
      <div className="card__social">
        <Label isBlue icon="icon-instagram" />
      </div>
    </a>
  );
};

export default InstagramCard;
